/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { calendarManualInterviewRequestSchema } from './calendar-manual-interview-request-schema';
import { candidateSchema } from './candidate-schema';
import { opportunitySchema } from './opportunity-schema';
import { userSchema } from './user-schema';
import { CandidateStatus } from "../enums";

export const clientRequestSchema: z.AnyZodObject = z.object({
  calendarManualInterviewRequests: 
    z.array(z.lazy(() => calendarManualInterviewRequestSchema))
  .nullish(),
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  candidateOpportunityStatus: z.nativeEnum(CandidateStatus).nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  notes: z.string().nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  rejectionLossCodes: z.array(z.string()).nullish(),
  updatedAt: z.string().datetime().nullish(),
  user: z.lazy(() => userSchema).nullish(),
  userId: z.string().uuid().nullish(),
});

export type ClientRequest = z.infer<typeof clientRequestSchema>;
